<div class="flex-container new-traveler-form">
    <div class="container">
        <section class="new-traveler-form-cont">
            <div class="twoColLayout main-content">
                <div class="registerForm-title-section col">
                    <h2 class="title">{{content?.['b2b.managetraveler.addnewtraveler']}}</h2>
                </div>

                <form class="form-new">
                    <!-- Corporate Information -->
                    <div class="f-col">
                        <div class="f-row filled-action-row">
                            <h6 class="title-subText m-bottom-8x">{{content?.['b2b.managetraveler.personalinfo']}}</h6>
                        </div>

                        <form class="form-info-section" [formGroup]="addNewTravelerForm">
                            <div class="f-row">
                                <div class="f-col">

                                    <ng-select autoBlurSelect [items]="newCustomCountries" groupBy="group"
                                        [searchFn]="_CommonService.customCountrySearchFn" formControlName="Nationality"
                                        bindValue="isoCode"
                                        [placeholder]="content?.['b2b.managetraveler.nationalityopt']"
                                        (contextmenu)="_CommonService.disableRightClick($event)"
                                        (paste)="_CommonService.onPasteBlocked($event)"
                                        (keypress)="_CommonService.blockInvalidCharacters1($event)">
                                        <ng-template ng-optgroup-tmp let-item="item"> {{ item.group }} </ng-template>
                                        <ng-template ng-option-tmp let-item="item">
                                            <span class="ng-option-label">
                                                <ng-container *ngIf="!!item?.newFlag?.src">
                                                    <img [src]="getImageUrl(item?.newFlag?.src)"
                                                        alt="Flag of {{ item.countryName }}" class="flag-img"
                                                        [height]="item.height" [width]="item.width" />
                                                </ng-container>
                                                {{ item?.countryName }}
                                            </span>
                                        </ng-template>
                                        <ng-template ng-label-tmp let-item="item">
                                            <span class="ng-value-label"> {{ item.nationality }} </span>
                                        </ng-template>
                                        <ng-template ng-notfound-tmp>
                                            <div class="no-items-found">
                                                <img src="assets/images/not-found.png" alt="No items found"
                                                    class="no-items-image" />
                                                <p>{{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
                                            </div>
                                        </ng-template>
                                    </ng-select>

                                    <mat-error class="px-4"
                                        *ngIf="addNewTravelerForm.get('Nationality')?.hasError('required') && addNewTravelerForm.get('Nationality')?.touched">
                                        {{content?.dictionary?.['b2b.managetraveler.selectnationality']}}</mat-error>

                                </div>
                            </div>

                            <div class="f-row">
                                <div class="f-col">

                                    <ng-select autoBlurSelect [items]="newCustomCountries" groupBy="group"
                                        [searchFn]="_CommonService.customCountrySearchFn" formControlName="residence"
                                        bindValue="isoCode"
                                        [placeholder]="content?.['b2b.managetraveler.placeofresidenceopt'] || 'Place of Residence (Optional)'"
                                        (contextmenu)="_CommonService.disableRightClick($event)"
                                        (paste)="_CommonService.onPasteBlocked($event)"
                                        (keypress)="_CommonService.blockInvalidCharacters1($event)">
                                        <ng-template ng-optgroup-tmp let-item="item"> {{ item.group }} </ng-template>
                                        <ng-template ng-option-tmp let-item="item">
                                            <span class="ng-option-label">
                                                <ng-container *ngIf="!!item?.newFlag?.src">
                                                    <img [src]="getImageUrl(item?.newFlag?.src)"
                                                        alt="Flag of {{ item.countryName }}" class="flag-img"
                                                        [height]="item.height" [width]="item.width" />
                                                </ng-container>
                                                {{ item?.countryName }}
                                            </span>
                                        </ng-template>
                                        <ng-template ng-label-tmp let-item="item">
                                            <span class="ng-value-label"> {{ item.countryName }} </span>
                                        </ng-template>
                                        <ng-template ng-notfound-tmp>
                                            <div class="no-items-found">
                                                <img src="assets/images/not-found.png" alt="No items found"
                                                    class="no-items-image" />
                                                <p>{{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
                                            </div>
                                        </ng-template>
                                    </ng-select>

                                    <mat-error class="px-4"
                                        *ngIf="addNewTravelerForm.get('residence')?.hasError('required') && addNewTravelerForm.get('residence')?.touched">
                                        {{content?.dictionary?.['b2b.register.selectpor']}}</mat-error>
                                </div>
                            </div>

                            <div class="f-row"
                                *ngIf="addNewTravelerForm.get('residence')?.value && addNewTravelerForm.get('Nationality')?.value">
                                <div class="f-col">
                                    <mat-form-field>
                                        <mat-label>{{this.CommonObj.docName || 'National ID/IQAMA/Passport'}}</mat-label>
                                        <!-- <input matInput  /> -->
                                        <input matInput formControlName="identityNumber" (blur)="verifyELM('nn')"
                                            data-dd-privacy="mask"
                                            (contextmenu)="_CommonService.disableRightClick($event)"
                                            (paste)="_CommonService.onPasteBlocked($event)"
                                            (keypress)="_CommonService.blockInvalidCharacters1($event)" />
                                        <!--   for duplicate cmp name check-->
                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('identityNumber')?.hasError('required') && addNewTravelerForm.get('identityNumber')?.touched">
                                            <!-- Show when Passport is selected -->
                                            <ng-container *ngIf="CommonObj.docType === 'passport'">
                                                {{ content?.dictionary?.['b2b.register.enterpassport'] || 'Please enter your passport number' }}
                                            </ng-container>

                                            <!-- Show when National ID is selected -->
                                            <ng-container *ngIf="CommonObj.docType == 'nationalID'">
                                                {{ content?.dictionary?.['b2b.register.enternationalid'] || 'Please enter your national ID' }}
                                            </ng-container>

                                            <!-- Show when Iqama is selected -->
                                            <ng-container *ngIf="CommonObj.docType == 'iqama'">
                                                {{ content?.dictionary?.['b2b.register.enteriqama'] || 'Please enter  your Iqama' }}
                                            </ng-container>
                                        </mat-error>

                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('identityNumber')?.hasError('pattern') && addNewTravelerForm.get('identityNumber')?.touched">
                                            <ng-container *ngIf="CommonObj.docType === 'passport'">
                                                {{ content?.dictionary?.['b2b.managetraveler.passportformat'] ||
                                                'Passport must be 6–12 alphanumeric characters.' }}
                                            </ng-container>
                                            <ng-container *ngIf="CommonObj.docType == 'nationalID'">
                                                {{ content?.dictionary?.['b2b.managetraveler.nationalidformat'] ||
                                                'National ID must be exactly 10 digits and should start with 1.' }}
                                            </ng-container>
                                            <ng-container *ngIf="CommonObj.docType == 'iqama'">
                                                {{ content?.dictionary?.['b2b.managetraveler.iqamaformat'] || 'Iqama must be exactly 10 digits and should start with 2.' }}
                                            </ng-container>
                                        </mat-error>
                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('identityNumber')?.hasError('elmError') ">
                                            {{content?.dictionary?.['b2b.register.InvalidIdNumber']}}</mat-error>
                                    </mat-form-field>

                                </div>
                            </div>

                            <div class="f-col hideCalendar open-calendar-bottom position-relative">
                                <mat-form-field
                                    (click)="showComponent('isDOBCalendarVisible','dateOfBirth'); $event.stopPropagation()"
                                    (contextmenu)="_CommonService.disableRightClick($event)"
                                    (paste)="_CommonService.onPasteBlocked($event)"
                                    (keypress)="_CommonService.blockInvalidCharacters1($event)">
                                    <mat-label>{{content?.['b2b.managetraveler.dateofbirth']}}</mat-label>
                                    <mat-icon fontSet="material-symbols-outlined" matSuffix> calendar_today </mat-icon>

                                    <input matInput #dobInput formControlName="dateOfBirth" readonly
                                        data-dd-privacy="mask" (blur)="verifyELM('nn')" />

                                    <mat-error
                                        *ngIf="addNewTravelerForm.get('dateOfBirth')?.hasError('required') && addNewTravelerForm.get('dateOfBirth')?.touched">
                                        {{content?.dictionary?.['b2b.passenger.errordateofbirth']}} </mat-error>
                                </mat-form-field>
                                <app-date-of-birth-calendar *ngIf="isChildVisible['isDOBCalendarVisible']"
                                    class="datepicker-content-container" (dateSelected)="onDateSelected($event)"
                                    (confirm)="onConfirm('isDOBCalendarVisible')"></app-date-of-birth-calendar>
                            </div>

                            <div class="f-col position-relative open-calendar-bottom"
                                *ngIf="addNewTravelerForm.get('residence')?.value && addNewTravelerForm.get('Nationality')?.value">
                                <mat-form-field appearance="fill"
                                    (click)="showComponent('isExpiaryCalendarVisible','docExpiary'); $event.stopPropagation()"
                                    (contextmenu)="_CommonService.disableRightClick($event)"
                                    (paste)="_CommonService.onPasteBlocked($event)"
                                    (keypress)="_CommonService.blockInvalidCharacters1($event)">
                                    <mat-label>{{this.CommonObj.docName + ' '}}
                                        {{content?.['b2b.managetraveler.expirydate']}}</mat-label>
                                    <input matInput formControlName="docExpiary" data-dd-privacy="mask"
                                        [value]="selectedExpiryDate ? (selectedExpiryDate | date: 'dd/MM/y') : ''"
                                        readonly />
                                    <mat-icon fontSet="material-symbols-outlined" matSuffix>calendar_today</mat-icon>
                                    <mat-error
                                        *ngIf="addNewTravelerForm.get('docExpiary')?.hasError('required') && addNewTravelerForm.get('docExpiary')?.touched">
                                        {{this.CommonObj.docName}}
                                        {{content?.dictionary?.['"b2b.register.expirydatereq'] || 'expiry date is required.'}} </mat-error>
                                </mat-form-field>
                                <app-expiry-date *ngIf="isChildVisible['isExpiaryCalendarVisible']"
                                    class="datepicker-content-container" [passengerTravelerCode]="'ADT'"
                                    (dateSelected)="onDateSelected2($event,'isExpiaryCalendarVisible')"
                                    (confirm)="onConfirm('isExpiaryCalendarVisible')"
                                    [filledDate]="selectedExpiryDate ? (selectedExpiryDate | date: 'dd/MM/y') : ''">
                                </app-expiry-date>
                            </div>



                            <div class="f-row two--ColLayout passenger-title-input">
                                <div class="f-col control-wrapper">
                                    <mat-form-field>
                                        <mat-label>{{content?.['b2b.managetraveler.title']}}</mat-label>
                                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">
                                            stat_minus_1 </mat-icon>
                                        <mat-select disableRipple formControlName="title"
                                            (contextmenu)="_CommonService.disableRightClick($event)"
                                            (paste)="_CommonService.onPasteBlocked($event)"
                                            (keypress)="_CommonService.blockInvalidCharacters1($event)">
                                            <mat-option [value]="title.Phrase"
                                                *ngFor="let title of titles">{{title.Phrase}}</mat-option>
                                        </mat-select>
                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('title')?.hasError('required') && addNewTravelerForm.get('title')?.touched">
                                            {{content?.dictionary?.['b2b.managetraveler.selectatitle']}} </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="f-col control-wrapper">
                                    <mat-form-field>
                                        <mat-label>{{content?.['b2b.managetraveler.firstname']}}</mat-label>
                                        <input matInput formControlName="firstname" data-dd-privacy="mask"
                                            (contextmenu)="_CommonService.disableRightClick($event)"
                                            (paste)="_CommonService.onPasteBlocked($event)"
                                            (keypress)="_CommonService.allowOnlyCharacters($event)" />
                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('firstname')?.hasError('required') && addNewTravelerForm.get('firstname')?.touched">
                                            {{content?.dictionary?.['b2b.register.enterfirstname']}} </mat-error>
                                        <mat-error *ngIf="addNewTravelerForm.get('firstname')?.hasError('maxlength')">
                                            {{content?.dictionary?.['b2b.register.cannotexceedfirstname']}} </mat-error>
                                        <!-- <mat-error> Please enter a valid input.</mat-error>  -->
                                        <mat-error *ngIf="addNewTravelerForm.get('firstname')?.hasError('minlength')">
                                            {{content?.dictionary?.['b2b.register.firstname2char']}} </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="f-row">

                                <div class="f-col">
                                    <mat-form-field>
                                        <mat-label>{{content?.['b2b.managetraveler.lastname']}}</mat-label>
                                        <!-- <input matInput  /> -->
                                        <input matInput formControlName="lastname" data-dd-privacy="mask"
                                            (contextmenu)="_CommonService.disableRightClick($event)"
                                            (paste)="_CommonService.onPasteBlocked($event)"
                                            (keypress)="_CommonService.allowOnlyCharacters($event)" />
                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('lastname')?.hasError('required') && addNewTravelerForm.get('lastname')?.touched">
                                            {{content?.dictionary?.['b2b.register.enterlastname']}} </mat-error>
                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('lastname')?.hasError('maxlength')&& addNewTravelerForm.get('lastname')?.touched">
                                            {{content?.dictionary?.['b2b.register.cannotexceedlastname']}}</mat-error>
                                        <!-- <mat-error> Please enter a valid input. </mat-error> -->
                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('lastname')?.hasError('minlength') && addNewTravelerForm.get('lastname')?.touched">
                                            {{content?.dictionary?.['b2b.register.lastname2char']}} </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="f-row">
                                <div class="f-col">
                                    <div class="f-row validation-col radio-group-container">
                                        <label class="mat-label"
                                            for="Gender">{{content?.['b2b.managetraveler.gender']}}</label>
                                        <mat-radio-group id="gender" aria-label="Select a gender"
                                            formControlName="gender">
                                            <mat-radio-button
                                                value="Male">{{content?.['b2b.managetraveler.male']}}</mat-radio-button>
                                            <mat-radio-button
                                                value="Female">{{content?.['b2b.managetraveler.female']}}</mat-radio-button>
                                        </mat-radio-group>
                                        <!-- <mat-error *ngIf="businessOwnerForm.get('gender')?.hasError('required') && businessOwnerForm.get('gender')?.touched"> Please select a gender. </mat-error> -->
                                    </div>
                                </div>
                            </div>

                            <div class="f-row">
                                <div class="f-col">
                                    <mat-form-field>
                                        <mat-label>{{content?.['b2b.managetraveler.employcode']}}</mat-label>
                                        <input matInput formControlName="empCode" data-dd-privacy="mask"
                                            (contextmenu)="_CommonService.disableRightClick($event)"
                                            (paste)="_CommonService.onPasteBlocked($event)"
                                            (keypress)="_CommonService.blockInvalidCharacters1($event)" />
                                        <mat-spinner *ngIf="isEmpCodeCheckLoading" matSuffix diameter="16"
                                            class="btn-inline-spinner"></mat-spinner>
                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('empCode')?.hasError('required') && addNewTravelerForm.get('empCode')?.touched">
                                            {{content?.dictionary?.['b2b.register.employeecodereq']}} </mat-error>
                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('empCode')?.hasError('minlength') && addNewTravelerForm.get('empCode')?.touched">
                                            {{content?.dictionary?.['b2b.register.employeecode4char']}} </mat-error>
                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('empCode')?.hasError('maxlength') && addNewTravelerForm.get('empCode')?.touched">
                                            {{content?.dictionary?.['b2b.register.cannotexceedempcode']}} </mat-error>
                                        <mat-error *ngIf="addNewTravelerForm.get('empCode')?.hasError('empCodeExists')">
                                            {{ addNewTravelerForm.get('empCode')?.getError('empCodeExists') }}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="f-row">
                                <div class="f-col">
                                    <mat-form-field>
                                        <mat-label>{{content?.['b2b.managetraveler.emailaddress']}}</mat-label>
                                        <input matInput formControlName="email" data-dd-privacy="mask"
                                            (contextmenu)="_CommonService.disableRightClick($event)"
                                            (paste)="_CommonService.onPasteBlocked($event)"
                                            (keypress)="_CommonService.blockInvalidCharacters($event)"
                                            (blur)="checkEmailExist()" />
                                        <mat-icon fontSet="material-symbols-outlined" matSuffix>mail</mat-icon>
                                        <mat-error *ngIf="addNewTravelerForm.get('email')?.hasError('existEmail')">
                                            {{content?.dictionary?.['b2b.register.emailexists']}}
                                        </mat-error>
                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('email')?.hasError('required') && addNewTravelerForm.get('email')?.touched">
                                            {{content?.dictionary?.['b2b.register.emailaddressreq']}} </mat-error>
                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('email')?.hasError('maxlength') && addNewTravelerForm.get('email')?.touched">
                                            {{content?.dictionary?.['b2b.register.cannotexceedemail']}} </mat-error>
                                        <!-- <mat-error> This email already exists. </mat-error> -->
                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('email')?.hasError('email') && addNewTravelerForm.get('email')?.touched">
                                            {{content?.dictionary?.['b2b.register.entervalidinput']}}</mat-error>
                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('email')?.hasError('isExist') && addNewTravelerForm.get('email')?.touched">
                                            {{content?.dictionary?.['b2b.managecompany.emailalreadyexists']}}
                                        </mat-error>

                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('email')?.hasError('domainMismatch') && addNewTravelerForm.get('email')?.touched">{{'Domain name does not match'}}</mat-error>

                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="f-row  two--ColLayout">
                                <div class="f-col">
                                    <ng-select autoBlurSelect [items]="newCustomCountries" groupBy="group"
                                        [searchFn]="_CommonService.customCountrySearchFn" formControlName="countryCode"
                                        bindValue="code" [placeholder]="content?.['b2b.managetraveler.countrycode']"
                                        (contextmenu)="_CommonService.disableRightClick($event)"
                                        (paste)="_CommonService.onPasteBlocked($event)"
                                        (keypress)="_CommonService.blockInvalidCharacters($event)">
                                        <ng-template ng-optgroup-tmp let-item="item"> {{ item.group }} </ng-template>
                                        <ng-template ng-option-tmp let-item="item">
                                            <span class="ng-option-label">
                                                <ng-container *ngIf="!!item?.newFlag?.src">
                                                    <img [src]="getImageUrl(item?.newFlag?.src)"
                                                        alt="Flag of {{ item.countryName }}" class="flag-img"
                                                        [height]="item.height" [width]="item.width" />
                                                </ng-container>
                                                {{ item.code }} ({{ item?.countryName }})
                                            </span>
                                        </ng-template>
                                        <ng-template ng-label-tmp let-item="item">
                                            <span class="ng-value-label"> {{ item.code }} </span>
                                        </ng-template>
                                        <ng-template ng-notfound-tmp>
                                            <div class="no-items-found">
                                                <img src="assets/images/not-found.png" alt="No items found"
                                                    class="no-items-image" />
                                                <p> {{content?.dictionary?.['b2b.managetraveler.nocountryfound']}}</p>
                                            </div>
                                        </ng-template>
                                    </ng-select>

                                    <mat-error class="px-4"
                                        *ngIf="addNewTravelerForm.get('countryCode')?.hasError('required') && addNewTravelerForm.get('countryCode')?.touched">
                                        {{content?.dictionary?.['b2b.register.selectcountrycode']}}</mat-error>

                                </div>
                                <div class="f-col">
                                    <mat-form-field>
                                        <mat-label>{{content?.['b2b.managetraveler.mobileno']}} </mat-label>
                                        <mat-icon fontSet="material-symbols-outlined" matSuffix>phone_android</mat-icon>
                                        <input type="text" matInput formControlName="mobileNumber"
                                            data-dd-privacy="mask"
                                            (contextmenu)="_CommonService.disableRightClick($event)"
                                            (paste)="_CommonService.onPasteBlocked($event)"
                                            (keypress)="_CommonService.allowNumberOnly($event)" />
                                        <mat-error
                                            *ngIf="addNewTravelerForm.get('mobileNumber')?.hasError('required') && addNewTravelerForm.get('mobileNumber')?.touched">{{content?.dictionary?.['b2b.register.mobilereq']}}
                                        </mat-error>

                                        <mat-error *ngIf=" addNewTravelerForm.get('mobileNumber')?.hasError('minlength') ">{{content?.dictionary?.['b2b.managecompany.cannotexceedmobilenumber']}} </mat-error>
                                        <mat-error *ngIf=" addNewTravelerForm.get('mobileNumber')?.hasError('maxlength') ">{{content?.dictionary?.['b2b.managecompany.cannotexceedmobilenumber']}} </mat-error>

                                        <!-- <mat-error
                                            *ngIf=" addNewTravelerForm.get('mobileNumber')?.hasError('pattern') ">{{content?.dictionary?.['b2b.register.10digitmobile']
                                            || 'Mobile number must be 10 digit.'}} </mat-error> -->


                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="f-row  two--ColLayout">
                                <div class="f-col">
                                    <mat-form-field>
                                        <mat-label>{{content?.['b2b.managetraveler.officelocation']}}</mat-label>
                                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">
                                            stat_minus_1 </mat-icon>
                                        <mat-select disableRipple formControlName="branch">
                                            <mat-option *ngFor="let branch of branchList"
                                                [value]="branch.corpBranchId">{{branch.corpBranchName}}</mat-option>

                                        </mat-select>
                                        <mat-error> {{content?.dictionary?.['b2b.managetraveler.officelocation']}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                                <div class="f-col">
                                    <mat-form-field>
                                        <mat-label>{{content?.['b2b.managetraveler.department']}}</mat-label>
                                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">
                                            stat_minus_1 </mat-icon>
                                        <mat-select disableRipple formControlName="department">
                                            <mat-option *ngFor="let dept of departmentLIst"
                                                [value]="dept.departmentId">{{dept.departmentName}}</mat-option>

                                        </mat-select>
                                        <mat-error> {{content?.dictionary?.['b2b.managetraveler.selectdepartment']}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="f-row">
                                <div class="f-col">
                                    <mat-form-field>
                                        <mat-label>{{content?.['b2b.managetraveler.designation']}}</mat-label>
                                        <mat-icon fontSet="material-symbols-outlined" matSuffix class="mat-select">
                                            stat_minus_1 </mat-icon>
                                        <mat-select disableRipple formControlName="designation">
                                            <mat-option *ngFor="let desi of designationList"
                                                [value]="desi.designationId">{{desi.designation}}</mat-option>

                                        </mat-select>
                                        <mat-error> {{content?.dictionary?.['b2b.managetraveler.selectdepartment']}}
                                        </mat-error>
                                    </mat-form-field>
                                </div>
                            </div>

                            <div class="f-row">
                                <div class="f-col">
                                    <div class="f-row validation-col radio-group-container">
                                        <label class="mat-label"
                                            for="UeserType">{{content?.['b2b.managetraveler.usertype']}}</label>
                                        <mat-radio-group id="UeserType" aria-label="Select a gender"
                                            formControlName="userType">
                                            <mat-radio-button
                                                value='0'>{{content?.['b2b.managetraveler.administrator']}}</mat-radio-button>
                                            <mat-radio-button
                                                value='1'>{{content?.['b2b.managetraveler.travelarranger']}}</mat-radio-button>
                                            <mat-radio-button
                                                value='2'>{{content?.['b2b.managetraveler.employee']}}</mat-radio-button>
                                        </mat-radio-group>
                                        <!-- <mat-error> Please select department. </mat-error> -->
                                    </div>
                                </div>
                            </div>


                            <div class="f-row justify-end m-top-8x btn-group">
                                <button mat-button class="button--secondary-small" type="button" (click)="onCancel()">
                                    {{content?.['b2b.managetraveler.cancel']}} </button>
                                <button
                                    class="button--primary-small d-flex align-items-center justify-content-center gap-2"
                                    mat-button (click)="onSubmit()"
                                    [class.disabled]="addNewTravelerForm.invalid || isInviteLoading"
                                    [disabled]="isInviteLoading">
                                    <span>{{content?.['b2b.managetraveler.sendinvite']}}</span>
                                    <mat-spinner *ngIf="isInviteLoading" diameter="20"
                                        class="btn-inline-spinner"></mat-spinner>
                                </button>
                            </div>
                        </form>
                    </div>
                </form>

            </div>

        </section>
    </div>
</div>